(function () {
  document.querySelectorAll('[data-product-carousel]').forEach(initCarousel);

  function initCarousel(section) {
    var track = section.querySelector('[data-carousel-track]');
    var prevBtn = section.querySelector('[data-carousel-prev]');
    var nextBtn = section.querySelector('[data-carousel-next]');
    var scrollbar = section.querySelector('[data-carousel-scrollbar]');
    var thumb = section.querySelector('[data-carousel-thumb]');

    if (!track) return;

    function getSlideWidth() {
      var slide = track.querySelector('.product-carousel__slide');
      if (!slide) return 300;
      return slide.offsetWidth + parseInt(getComputedStyle(track).gap || '0', 10);
    }

    function updateNavState() {
      var scrollLeft = track.scrollLeft;
      var maxScroll = track.scrollWidth - track.clientWidth;

      if (prevBtn) prevBtn.disabled = scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = scrollLeft >= maxScroll - 2;
    }

    function updateScrollbar() {
      if (!scrollbar || !thumb) return;

      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        scrollbar.style.display = 'none';
        return;
      }

      scrollbar.style.display = '';
      var ratio = track.clientWidth / track.scrollWidth;
      var thumbWidth = Math.max(ratio * 100, 15);
      thumb.style.width = thumbWidth + '%';

      var progress = track.scrollLeft / maxScroll;
      var thumbTravel = 100 - thumbWidth;
      thumb.style.left = progress * thumbTravel + '%';
    }

    function scrollBy(direction) {
      var amount = getSlideWidth() * 2;
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollBy(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollBy(1); });

    track.addEventListener('scroll', function () {
      updateNavState();
      updateScrollbar();
    }, { passive: true });

    var dragging = false;
    var startX = 0;
    var startLeft = 0;

    if (scrollbar && thumb) {
      scrollbar.addEventListener('mousedown', function (e) {
        dragging = true;
        startX = e.clientX;
        startLeft = track.scrollLeft;
        document.body.style.userSelect = 'none';
      });

      document.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        var scrollbarWidth = scrollbar.offsetWidth;
        var maxScroll = track.scrollWidth - track.clientWidth;
        track.scrollLeft = startLeft + (dx / scrollbarWidth) * maxScroll;
      });

      document.addEventListener('mouseup', function () {
        if (dragging) {
          dragging = false;
          document.body.style.userSelect = '';
        }
      });
    }

    function updateNavHeight() {
      var firstImage = track.querySelector('.product-card__image');
      if (!firstImage || (!prevBtn && !nextBtn)) return;
      var h = firstImage.offsetHeight + 'px';
      if (prevBtn) prevBtn.style.height = h;
      if (nextBtn) nextBtn.style.height = h;
    }

    updateNavState();
    updateScrollbar();
    updateNavHeight();

    window.addEventListener('resize', function () {
      updateNavState();
      updateScrollbar();
      updateNavHeight();
    });
  }
})();
